/**
 * Fonte única das variáveis de ambiente do frontend (Fase 1 — imagem única).
 *
 * Ordem de resolução:
 *  1. window.__NCH_ENV — injetado em RUNTIME pelo blade (partials/nch-env),
 *     com os valores do tenant vindos do config PHP. É o caminho de produção
 *     na imagem única (o bundle é o mesmo para todos os clientes).
 *  2. import.meta.env.VITE_* — valores "assados" no build. Mantido como
 *     fallback para o `yarn dev` local e compatibilidade com builds antigos.
 *
 * Todas as chaves são referenciadas estaticamente (exigência do Vite para a
 * substituição em build). Não acessar import.meta.env dinamicamente.
 */

const runtime = (typeof window !== 'undefined' && window.__NCH_ENV) || {};

const pick = (runtimeValue, buildValue) =>
    runtimeValue !== undefined && runtimeValue !== null
        ? runtimeValue
        : buildValue;

export const NCH_ENV = {
    APP_NAME: pick(runtime.APP_NAME, import.meta.env.VITE_APP_NAME),
    APP_URL: pick(runtime.APP_URL, import.meta.env.VITE_APP_URL),
    APP_HOST: pick(runtime.APP_HOST, import.meta.env.VITE_APP_HOST),
    APP_TYPE: pick(runtime.APP_TYPE, 'free_sale'),
    BROADCAST_PREFIX: pick(runtime.BROADCAST_PREFIX, import.meta.env.VITE_BROADCAST_PREFIX),
    BROADCAST_ASSETS_PREFIX: pick(runtime.BROADCAST_ASSETS_PREFIX, import.meta.env.VITE_BROADCAST_ASSETS_PREFIX),
    ASSETS_API: pick(runtime.ASSETS_API, import.meta.env.VITE_ASSETS_API),
    ASSETS_SOCKET: pick(runtime.ASSETS_SOCKET, import.meta.env.VITE_ASSETS_SOCKET),
    HUB_API: pick(runtime.HUB_API, import.meta.env.VITE_HUB_API),
    JMV_MIDDLEWARE: pick(runtime.JMV_MIDDLEWARE, import.meta.env.VITE_JMV_MIDDLEWARE),
    NOCHALKS_MIDDLEWARE: pick(runtime.NOCHALKS_MIDDLEWARE, import.meta.env.VITE_NOCHALKS_MIDDLEWARE),
    NOMINATIN_API: pick(runtime.NOMINATIN_API, import.meta.env.VITE_NOMINATIN_API),
    ZIP_API: pick(runtime.ZIP_API, import.meta.env.VITE_ZIP_API),
    API_JMVSTREAM: pick(runtime.API_JMVSTREAM, import.meta.env.VITE_API_JMVSTREAM),
    PLAYER_DOMAIN: pick(runtime.PLAYER_DOMAIN, import.meta.env.VITE_PLAYER_DOMAIN),
    PUSHER_APP_KEY: pick(runtime.PUSHER_APP_KEY, import.meta.env.VITE_PUSHER_APP_KEY),
    PUSHER_HOST: pick(runtime.PUSHER_HOST, import.meta.env.VITE_PUSHER_HOST),
    PUSHER_PORT: pick(runtime.PUSHER_PORT, import.meta.env.VITE_PUSHER_PORT),
    PUSHER_SCHEME: pick(runtime.PUSHER_SCHEME, import.meta.env.VITE_PUSHER_SCHEME),
    PUSHER_APP_CLUSTER: pick(runtime.PUSHER_APP_CLUSTER, import.meta.env.VITE_PUSHER_APP_CLUSTER),
};

export default NCH_ENV;
